import * as ambassadorWixBookingsV2Booking from './bookings-v2-booking-bookings.http.js';
import * as ambassadorWixBookingsV2BookingTypes from './bookings-v2-booking-bookings.types.js';
import * as ambassadorWixBookingsV2BookingUniversalTypes from './bookings-v2-booking-bookings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function confirmOrDeclineBooking(): __PublicMethodMetaInfo<
  'POST',
  { bookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.ConfirmOrDeclineBookingRequest,
  ambassadorWixBookingsV2BookingTypes.ConfirmOrDeclineBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.ConfirmOrDeclineBookingResponse,
  ambassadorWixBookingsV2BookingTypes.ConfirmOrDeclineBookingResponse
> {
  const payload = { bookingId: ':bookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.confirmOrDeclineBooking(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/confirmation/{bookingId}:confirmOrDecline',
    pathParams: { bookingId: 'bookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkConfirmOrDeclineBooking(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV2BookingUniversalTypes.BulkConfirmOrDeclineBookingRequest,
  ambassadorWixBookingsV2BookingTypes.BulkConfirmOrDeclineBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.BulkConfirmOrDeclineBookingResponse,
  ambassadorWixBookingsV2BookingTypes.BulkConfirmOrDeclineBookingResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.bulkConfirmOrDeclineBooking(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/bookings/confirmOrDecline',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bookingsCancelBookingAnonymously(): __PublicMethodMetaInfo<
  'POST',
  { token: string },
  ambassadorWixBookingsV2BookingUniversalTypes.V1CancelBookingAnonymouslyRequest,
  ambassadorWixBookingsV2BookingTypes.V1CancelBookingAnonymouslyRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.V1CancelBookingAnonymouslyResponse,
  ambassadorWixBookingsV2BookingTypes.V1CancelBookingAnonymouslyResponse
> {
  const payload = { token: ':token' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.bookingsCancelBookingAnonymously(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/anonymous-bookings/{token}/cancel',
    pathParams: { token: 'token' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bookingsRescheduleBookingAnonymously(): __PublicMethodMetaInfo<
  'POST',
  { token: string },
  ambassadorWixBookingsV2BookingUniversalTypes.V1RescheduleBookingAnonymouslyRequest,
  ambassadorWixBookingsV2BookingTypes.V1RescheduleBookingAnonymouslyRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.V1RescheduleBookingAnonymouslyResponse,
  ambassadorWixBookingsV2BookingTypes.V1RescheduleBookingAnonymouslyResponse
> {
  const payload = { token: ':token' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.bookingsRescheduleBookingAnonymously(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/anonymous-bookings/{token}/reschedule',
    pathParams: { token: 'token' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bookingsGetBookingAnonymously(): __PublicMethodMetaInfo<
  'GET',
  { token: string },
  ambassadorWixBookingsV2BookingUniversalTypes.V1GetBookingAnonymouslyRequest,
  ambassadorWixBookingsV2BookingTypes.V1GetBookingAnonymouslyRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.V1GetBookingAnonymouslyResponse,
  ambassadorWixBookingsV2BookingTypes.V1GetBookingAnonymouslyResponse
> {
  const payload = { token: ':token' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.bookingsGetBookingAnonymously(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/anonymous-bookings/{token}',
    pathParams: { token: 'token' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getServiceAnonymously(): __PublicMethodMetaInfo<
  'GET',
  { token: string },
  ambassadorWixBookingsV2BookingUniversalTypes.GetServiceAnonymouslyRequest,
  ambassadorWixBookingsV2BookingTypes.GetServiceAnonymouslyRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.GetServiceAnonymouslyResponse,
  ambassadorWixBookingsV2BookingTypes.GetServiceAnonymouslyResponse
> {
  const payload = { token: ':token' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.getServiceAnonymously(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/anonymous-bookings/{token}/service',
    pathParams: { token: 'token' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAnonymousActionToken(): __PublicMethodMetaInfo<
  'GET',
  { bookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.GetAnonymousActionTokenRequest,
  ambassadorWixBookingsV2BookingTypes.GetAnonymousActionTokenRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.GetAnonymousActionTokenResponse,
  ambassadorWixBookingsV2BookingTypes.GetAnonymousActionTokenResponse
> {
  const payload = { bookingId: ':bookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.getAnonymousActionToken(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/anonymous-bookings/{bookingId}/token',
    pathParams: { bookingId: 'bookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createMultiServiceBooking(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV2BookingUniversalTypes.CreateMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingTypes.CreateMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.CreateMultiServiceBookingResponse,
  ambassadorWixBookingsV2BookingTypes.CreateMultiServiceBookingResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.createMultiServiceBooking(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/multi_service_bookings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function rescheduleMultiServiceBooking(): __PublicMethodMetaInfo<
  'POST',
  { multiServiceBookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.RescheduleMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingTypes.RescheduleMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.RescheduleMultiServiceBookingResponse,
  ambassadorWixBookingsV2BookingTypes.RescheduleMultiServiceBookingResponse
> {
  const payload = { multiServiceBookingId: ':multiServiceBookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.rescheduleMultiServiceBooking(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/multi_service_bookings/{multiServiceBookingId}/reschedule',
    pathParams: { multiServiceBookingId: 'multiServiceBookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getMultiServiceBookingAvailability(): __PublicMethodMetaInfo<
  'POST',
  { multiServiceBookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.GetMultiServiceBookingAvailabilityRequest,
  ambassadorWixBookingsV2BookingTypes.GetMultiServiceBookingAvailabilityRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.GetMultiServiceBookingAvailabilityResponse,
  ambassadorWixBookingsV2BookingTypes.GetMultiServiceBookingAvailabilityResponse
> {
  const payload = { multiServiceBookingId: ':multiServiceBookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.getMultiServiceBookingAvailability(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/multi_service_bookings/{multiServiceBookingId}/get_availability',
    pathParams: { multiServiceBookingId: 'multiServiceBookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelMultiServiceBooking(): __PublicMethodMetaInfo<
  'POST',
  { multiServiceBookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.CancelMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingTypes.CancelMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.CancelMultiServiceBookingResponse,
  ambassadorWixBookingsV2BookingTypes.CancelMultiServiceBookingResponse
> {
  const payload = { multiServiceBookingId: ':multiServiceBookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.cancelMultiServiceBooking(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/multi_service_bookings/{multiServiceBookingId}/cancel',
    pathParams: { multiServiceBookingId: 'multiServiceBookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function markMultiServiceBookingAsPending(): __PublicMethodMetaInfo<
  'POST',
  { multiServiceBookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.MarkMultiServiceBookingAsPendingRequest,
  ambassadorWixBookingsV2BookingTypes.MarkMultiServiceBookingAsPendingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.MarkMultiServiceBookingAsPendingResponse,
  ambassadorWixBookingsV2BookingTypes.MarkMultiServiceBookingAsPendingResponse
> {
  const payload = { multiServiceBookingId: ':multiServiceBookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.markMultiServiceBookingAsPending(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/multi_service_bookings/{multiServiceBookingId}/mark_as_pending',
    pathParams: { multiServiceBookingId: 'multiServiceBookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function confirmMultiServiceBooking(): __PublicMethodMetaInfo<
  'POST',
  { multiServiceBookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.ConfirmMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingTypes.ConfirmMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.ConfirmMultiServiceBookingResponse,
  ambassadorWixBookingsV2BookingTypes.ConfirmMultiServiceBookingResponse
> {
  const payload = { multiServiceBookingId: ':multiServiceBookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.confirmMultiServiceBooking(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/multi_service_bookings/{multiServiceBookingId}/confirm',
    pathParams: { multiServiceBookingId: 'multiServiceBookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function declineMultiServiceBooking(): __PublicMethodMetaInfo<
  'POST',
  { multiServiceBookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.DeclineMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingTypes.DeclineMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.DeclineMultiServiceBookingResponse,
  ambassadorWixBookingsV2BookingTypes.DeclineMultiServiceBookingResponse
> {
  const payload = { multiServiceBookingId: ':multiServiceBookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.declineMultiServiceBooking(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/multi_service_bookings/{multiServiceBookingId}/decline',
    pathParams: { multiServiceBookingId: 'multiServiceBookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkGetMultiServiceBookingAllowedActions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV2BookingUniversalTypes.BulkGetMultiServiceBookingAllowedActionsRequest,
  ambassadorWixBookingsV2BookingTypes.BulkGetMultiServiceBookingAllowedActionsRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.BulkGetMultiServiceBookingAllowedActionsResponse,
  ambassadorWixBookingsV2BookingTypes.BulkGetMultiServiceBookingAllowedActionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.bulkGetMultiServiceBookingAllowedActions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/multi_service_bookings/get_allowed_actions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getMultiServiceBooking(): __PublicMethodMetaInfo<
  'GET',
  { multiServiceBookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.GetMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingTypes.GetMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.GetMultiServiceBookingResponse,
  ambassadorWixBookingsV2BookingTypes.GetMultiServiceBookingResponse
> {
  const payload = { multiServiceBookingId: ':multiServiceBookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.getMultiServiceBooking(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/multi_service_bookings/{multiServiceBookingId}',
    pathParams: { multiServiceBookingId: 'multiServiceBookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addBookingsToMultiServiceBooking(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV2BookingUniversalTypes.AddBookingsToMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingTypes.AddBookingsToMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.AddBookingsToMultiServiceBookingResponse,
  ambassadorWixBookingsV2BookingTypes.AddBookingsToMultiServiceBookingResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.addBookingsToMultiServiceBooking(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/multi_service_bookings/add_bookings_to_multi_service_booking',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeBookingsFromMultiServiceBooking(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV2BookingUniversalTypes.RemoveBookingsFromMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingTypes.RemoveBookingsFromMultiServiceBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.RemoveBookingsFromMultiServiceBookingResponse,
  ambassadorWixBookingsV2BookingTypes.RemoveBookingsFromMultiServiceBookingResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.removeBookingsFromMultiServiceBooking(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/multi_service_bookings/remove_bookings_from_multi_service_booking',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createBooking(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV2BookingUniversalTypes.CreateBookingRequest,
  ambassadorWixBookingsV2BookingTypes.CreateBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.CreateBookingResponse,
  ambassadorWixBookingsV2BookingTypes.CreateBookingResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.createBooking(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bookings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateBooking(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV2BookingUniversalTypes.BulkCreateBookingRequest,
  ambassadorWixBookingsV2BookingTypes.BulkCreateBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.BulkCreateBookingResponse,
  ambassadorWixBookingsV2BookingTypes.BulkCreateBookingResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.bulkCreateBooking(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/bookings/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function rescheduleBooking(): __PublicMethodMetaInfo<
  'POST',
  { bookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.RescheduleBookingRequest,
  ambassadorWixBookingsV2BookingTypes.RescheduleBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.RescheduleBookingResponse,
  ambassadorWixBookingsV2BookingTypes.RescheduleBookingResponse
> {
  const payload = { bookingId: ':bookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.rescheduleBooking(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bookings/{bookingId}/reschedule',
    pathParams: { bookingId: 'bookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function confirmBooking(): __PublicMethodMetaInfo<
  'POST',
  { bookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.ConfirmBookingRequest,
  ambassadorWixBookingsV2BookingTypes.ConfirmBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.ConfirmBookingResponse,
  ambassadorWixBookingsV2BookingTypes.ConfirmBookingResponse
> {
  const payload = { bookingId: ':bookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.bookingsConfirmBooking(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bookings/{bookingId}/confirm',
    pathParams: { bookingId: 'bookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setBookingSubmissionId(): __PublicMethodMetaInfo<
  'POST',
  { bookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.SetBookingSubmissionIdRequest,
  ambassadorWixBookingsV2BookingTypes.SetBookingSubmissionIdRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.SetBookingSubmissionIdResponse,
  ambassadorWixBookingsV2BookingTypes.SetBookingSubmissionIdResponse
> {
  const payload = { bookingId: ':bookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.setBookingSubmissionId(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bookings/{bookingId}/set-booking-submission-id',
    pathParams: { bookingId: 'bookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExtendedFields(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixBookingsV2BookingUniversalTypes.UpdateExtendedFieldsRequest,
  ambassadorWixBookingsV2BookingTypes.UpdateExtendedFieldsRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.UpdateExtendedFieldsResponse,
  ambassadorWixBookingsV2BookingTypes.UpdateExtendedFieldsResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.updateExtendedFields(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bookings/{id}/update_extended_fields',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function declineBooking(): __PublicMethodMetaInfo<
  'POST',
  { bookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.DeclineBookingRequest,
  ambassadorWixBookingsV2BookingTypes.DeclineBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.DeclineBookingResponse,
  ambassadorWixBookingsV2BookingTypes.DeclineBookingResponse
> {
  const payload = { bookingId: ':bookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.bookingsDeclineBooking(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bookings/{bookingId}/decline',
    pathParams: { bookingId: 'bookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelBooking(): __PublicMethodMetaInfo<
  'POST',
  { bookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.CancelBookingRequest,
  ambassadorWixBookingsV2BookingTypes.CancelBookingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.CancelBookingResponse,
  ambassadorWixBookingsV2BookingTypes.CancelBookingResponse
> {
  const payload = { bookingId: ':bookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.bookingsCancelBooking(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bookings/{bookingId}/cancel',
    pathParams: { bookingId: 'bookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateNumberOfParticipants(): __PublicMethodMetaInfo<
  'POST',
  { bookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.UpdateNumberOfParticipantsRequest,
  ambassadorWixBookingsV2BookingTypes.UpdateNumberOfParticipantsRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.UpdateNumberOfParticipantsResponse,
  ambassadorWixBookingsV2BookingTypes.UpdateNumberOfParticipantsResponse
> {
  const payload = { bookingId: ':bookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.bookingsUpdateNumberOfParticipants(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bookings/{bookingId}/update_number_of_participants',
    pathParams: { bookingId: 'bookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCalculateAllowedActions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV2BookingUniversalTypes.BulkCalculateAllowedActionsRequest,
  ambassadorWixBookingsV2BookingTypes.BulkCalculateAllowedActionsRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.BulkCalculateAllowedActionsResponse,
  ambassadorWixBookingsV2BookingTypes.BulkCalculateAllowedActionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.bulkCalculateAllowedActions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/bookings/calculate_allowed_actions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function markBookingAsPending(): __PublicMethodMetaInfo<
  'POST',
  { bookingId: string },
  ambassadorWixBookingsV2BookingUniversalTypes.MarkBookingAsPendingRequest,
  ambassadorWixBookingsV2BookingTypes.MarkBookingAsPendingRequest,
  ambassadorWixBookingsV2BookingUniversalTypes.MarkBookingAsPendingResponse,
  ambassadorWixBookingsV2BookingTypes.MarkBookingAsPendingResponse
> {
  const payload = { bookingId: ':bookingId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Booking.markBookingAsPending(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bookings/{bookingId}/mark_booking_as_pending',
    pathParams: { bookingId: 'bookingId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Booking as BookingOriginal,
  BookingParticipantsInfoOneOf as BookingParticipantsInfoOneOfOriginal,
  MultiServiceBookingType as MultiServiceBookingTypeOriginal,
  MultiServiceBookingTypeWithLiterals as MultiServiceBookingTypeWithLiteralsOriginal,
  BookedEntity as BookedEntityOriginal,
  BookedEntityItemOneOf as BookedEntityItemOneOfOriginal,
  BookedSlot as BookedSlotOriginal,
  BookedResource as BookedResourceOriginal,
  ResourceTransparency as ResourceTransparencyOriginal,
  ResourceTransparencyWithLiterals as ResourceTransparencyWithLiteralsOriginal,
  Location as LocationOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  V2PhoneCall as V2PhoneCallOriginal,
  ResourceSelection as ResourceSelectionOriginal,
  SelectionMethod as SelectionMethodOriginal,
  SelectionMethodWithLiterals as SelectionMethodWithLiteralsOriginal,
  BookedSchedule as BookedScheduleOriginal,
  ContactDetails as ContactDetailsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  CustomFormField as CustomFormFieldOriginal,
  ValueType as ValueTypeOriginal,
  ValueTypeWithLiterals as ValueTypeWithLiteralsOriginal,
  BookingStatus as BookingStatusOriginal,
  BookingStatusWithLiterals as BookingStatusWithLiteralsOriginal,
  PaymentStatus as PaymentStatusOriginal,
  PaymentStatusWithLiterals as PaymentStatusWithLiteralsOriginal,
  SelectedPaymentOption as SelectedPaymentOptionOriginal,
  SelectedPaymentOptionWithLiterals as SelectedPaymentOptionWithLiteralsOriginal,
  BookingSource as BookingSourceOriginal,
  Platform as PlatformOriginal,
  PlatformWithLiterals as PlatformWithLiteralsOriginal,
  Actor as ActorOriginal,
  ActorWithLiterals as ActorWithLiteralsOriginal,
  ParticipantNotification as ParticipantNotificationOriginal,
  CommonIdentificationData as CommonIdentificationDataOriginal,
  CommonIdentificationDataIdOneOf as CommonIdentificationDataIdOneOfOriginal,
  IdentificationDataIdentityType as IdentificationDataIdentityTypeOriginal,
  IdentificationDataIdentityTypeWithLiterals as IdentificationDataIdentityTypeWithLiteralsOriginal,
  FlowControlSettings as FlowControlSettingsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  ParticipantChoices as ParticipantChoicesOriginal,
  ServiceChoices as ServiceChoicesOriginal,
  ServiceChoice as ServiceChoiceOriginal,
  ServiceChoiceChoiceOneOf as ServiceChoiceChoiceOneOfOriginal,
  Duration as DurationOriginal,
  MultiServiceBookingInfo as MultiServiceBookingInfoOriginal,
  BookedAddOn as BookedAddOnOriginal,
  BookingFormFilled as BookingFormFilledOriginal,
  V2CreateBookingRequest as V2CreateBookingRequestOriginal,
  V2CreateBookingRequestBookableItemOneOf as V2CreateBookingRequestBookableItemOneOfOriginal,
  V2CreateBookingRequestParticipantsInfoOneOf as V2CreateBookingRequestParticipantsInfoOneOfOriginal,
  Slot as SlotOriginal,
  SlotResource as SlotResourceOriginal,
  PhoneCall as PhoneCallOriginal,
  CreateBookingRequestFlowControlSettings as CreateBookingRequestFlowControlSettingsOriginal,
  V2CreateBookingResponse as V2CreateBookingResponseOriginal,
  V2CancelBookingRequest as V2CancelBookingRequestOriginal,
  CancelBookingRequestFlowControlSettings as CancelBookingRequestFlowControlSettingsOriginal,
  V2CancelBookingResponse as V2CancelBookingResponseOriginal,
  V2RescheduleBookingRequest as V2RescheduleBookingRequestOriginal,
  V2RescheduleBookingRequestParticipantsInfoOneOf as V2RescheduleBookingRequestParticipantsInfoOneOfOriginal,
  RescheduleBookingRequestFlowControlSettings as RescheduleBookingRequestFlowControlSettingsOriginal,
  V2RescheduleBookingResponse as V2RescheduleBookingResponseOriginal,
  V2ConfirmBookingRequest as V2ConfirmBookingRequestOriginal,
  V2ConfirmBookingResponse as V2ConfirmBookingResponseOriginal,
  V2DeclineBookingRequest as V2DeclineBookingRequestOriginal,
  V2DeclineBookingResponse as V2DeclineBookingResponseOriginal,
  V2UpdateNumberOfParticipantsRequest as V2UpdateNumberOfParticipantsRequestOriginal,
  V2UpdateNumberOfParticipantsRequestParticipantsInfoOneOf as V2UpdateNumberOfParticipantsRequestParticipantsInfoOneOfOriginal,
  V2UpdateNumberOfParticipantsResponse as V2UpdateNumberOfParticipantsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  WebhooksIdentificationData as WebhooksIdentificationDataOriginal,
  WebhooksIdentificationDataIdOneOf as WebhooksIdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  ConfirmOrDeclineBookingRequest as ConfirmOrDeclineBookingRequestOriginal,
  ConfirmOrDeclineBookingResponse as ConfirmOrDeclineBookingResponseOriginal,
  BulkConfirmOrDeclineBookingRequest as BulkConfirmOrDeclineBookingRequestOriginal,
  BulkConfirmOrDeclineBookingRequestBookingDetails as BulkConfirmOrDeclineBookingRequestBookingDetailsOriginal,
  BulkConfirmOrDeclineBookingResponse as BulkConfirmOrDeclineBookingResponseOriginal,
  BulkBookingResult as BulkBookingResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  V1CancelBookingAnonymouslyRequest as V1CancelBookingAnonymouslyRequestOriginal,
  V1CancelBookingAnonymouslyResponse as V1CancelBookingAnonymouslyResponseOriginal,
  V1RescheduleBookingAnonymouslyRequest as V1RescheduleBookingAnonymouslyRequestOriginal,
  V2Slot as V2SlotOriginal,
  LocationLocationType as LocationLocationTypeOriginal,
  LocationLocationTypeWithLiterals as LocationLocationTypeWithLiteralsOriginal,
  SlotSlotResource as SlotSlotResourceOriginal,
  SlotLocation as SlotLocationOriginal,
  V1RescheduleBookingAnonymouslyResponse as V1RescheduleBookingAnonymouslyResponseOriginal,
  V1GetBookingAnonymouslyRequest as V1GetBookingAnonymouslyRequestOriginal,
  V1RequestedFields as V1RequestedFieldsOriginal,
  V1RequestedFieldsWithLiterals as V1RequestedFieldsWithLiteralsOriginal,
  V1GetBookingAnonymouslyResponse as V1GetBookingAnonymouslyResponseOriginal,
  V1AllowedAnonymousActions as V1AllowedAnonymousActionsOriginal,
  BookingFee as BookingFeeOriginal,
  CancellationFee as CancellationFeeOriginal,
  Money as MoneyOriginal,
  BookingFeeStatus as BookingFeeStatusOriginal,
  BookingFeeStatusWithLiterals as BookingFeeStatusWithLiteralsOriginal,
  Trigger as TriggerOriginal,
  TriggerWithLiterals as TriggerWithLiteralsOriginal,
  PolicyDetails as PolicyDetailsOriginal,
  GetServiceAnonymouslyRequest as GetServiceAnonymouslyRequestOriginal,
  RequestedFields as RequestedFieldsOriginal,
  RequestedFieldsWithLiterals as RequestedFieldsWithLiteralsOriginal,
  GetServiceAnonymouslyResponse as GetServiceAnonymouslyResponseOriginal,
  Service as ServiceOriginal,
  ServiceType as ServiceTypeOriginal,
  ServiceTypeWithLiterals as ServiceTypeWithLiteralsOriginal,
  Media as MediaOriginal,
  MediaItem as MediaItemOriginal,
  MediaItemItemOneOf as MediaItemItemOneOfOriginal,
  Image as ImageOriginal,
  Category as CategoryOriginal,
  Form as FormOriginal,
  FormSettings as FormSettingsOriginal,
  Payment as PaymentOriginal,
  PaymentRateOneOf as PaymentRateOneOfOriginal,
  RateType as RateTypeOriginal,
  RateTypeWithLiterals as RateTypeWithLiteralsOriginal,
  FixedPayment as FixedPaymentOriginal,
  CommonMoney as CommonMoneyOriginal,
  CustomPayment as CustomPaymentOriginal,
  VariedPayment as VariedPaymentOriginal,
  SubscriptionPayment as SubscriptionPaymentOriginal,
  FrequencyType as FrequencyTypeOriginal,
  FrequencyTypeWithLiterals as FrequencyTypeWithLiteralsOriginal,
  FirstChargeDateType as FirstChargeDateTypeOriginal,
  FirstChargeDateTypeWithLiterals as FirstChargeDateTypeWithLiteralsOriginal,
  FullUpfrontPayment as FullUpfrontPaymentOriginal,
  PaymentOptions as PaymentOptionsOriginal,
  AddOnPaymentOptions as AddOnPaymentOptionsOriginal,
  AddOnPaymentOptionsWithLiterals as AddOnPaymentOptionsWithLiteralsOriginal,
  DiscountInfo as DiscountInfoOriginal,
  OnlineBooking as OnlineBookingOriginal,
  Conferencing as ConferencingOriginal,
  V2Location as V2LocationOriginal,
  V2LocationOptionsOneOf as V2LocationOptionsOneOfOriginal,
  LocationTypeEnumLocationType as LocationTypeEnumLocationTypeOriginal,
  LocationTypeEnumLocationTypeWithLiterals as LocationTypeEnumLocationTypeWithLiteralsOriginal,
  CommonAddress as CommonAddressOriginal,
  CommonAddressStreetOneOf as CommonAddressStreetOneOfOriginal,
  CommonStreetAddress as CommonStreetAddressOriginal,
  CommonAddressLocation as CommonAddressLocationOriginal,
  BusinessLocationOptions as BusinessLocationOptionsOriginal,
  CustomLocationOptions as CustomLocationOptionsOriginal,
  BookingPolicy as BookingPolicyOriginal,
  PolicyDescription as PolicyDescriptionOriginal,
  LimitEarlyBookingPolicy as LimitEarlyBookingPolicyOriginal,
  LimitLateBookingPolicy as LimitLateBookingPolicyOriginal,
  BookAfterStartPolicy as BookAfterStartPolicyOriginal,
  CancellationPolicy as CancellationPolicyOriginal,
  ReschedulePolicy as ReschedulePolicyOriginal,
  WaitlistPolicy as WaitlistPolicyOriginal,
  ParticipantsPolicy as ParticipantsPolicyOriginal,
  ResourcesPolicy as ResourcesPolicyOriginal,
  CancellationFeePolicy as CancellationFeePolicyOriginal,
  CancellationWindow as CancellationWindowOriginal,
  CancellationWindowFeeOneOf as CancellationWindowFeeOneOfOriginal,
  SaveCreditCardPolicy as SaveCreditCardPolicyOriginal,
  StaffSortingPolicy as StaffSortingPolicyOriginal,
  StaffSortingPolicyOptionsOneOf as StaffSortingPolicyOptionsOneOfOriginal,
  RankingOrder as RankingOrderOriginal,
  RankingOrderWithLiterals as RankingOrderWithLiteralsOriginal,
  SortingMethodType as SortingMethodTypeOriginal,
  SortingMethodTypeWithLiterals as SortingMethodTypeWithLiteralsOriginal,
  RankingOptions as RankingOptionsOriginal,
  CustomOptions as CustomOptionsOriginal,
  IntakeFormPolicy as IntakeFormPolicyOriginal,
  Timing as TimingOriginal,
  TimingWithLiterals as TimingWithLiteralsOriginal,
  CompletionRequirement as CompletionRequirementOriginal,
  CompletionRequirementWithLiterals as CompletionRequirementWithLiteralsOriginal,
  Schedule as ScheduleOriginal,
  AvailabilityConstraints as AvailabilityConstraintsOriginal,
  V2Duration as V2DurationOriginal,
  DurationRange as DurationRangeOriginal,
  DurationRangeConfigOneOf as DurationRangeConfigOneOfOriginal,
  UnitType as UnitTypeOriginal,
  UnitTypeWithLiterals as UnitTypeWithLiteralsOriginal,
  HourlyConfig as HourlyConfigOriginal,
  DailyConfig as DailyConfigOriginal,
  StaffMember as StaffMemberOriginal,
  StaffMediaItem as StaffMediaItemOriginal,
  StaffMediaItemItemOneOf as StaffMediaItemItemOneOfOriginal,
  StaffMemberDetails as StaffMemberDetailsOriginal,
  ResourceGroup as ResourceGroupOriginal,
  ResourceIds as ResourceIdsOriginal,
  ServiceResource as ServiceResourceOriginal,
  ServiceResourceSelectionOneOf as ServiceResourceSelectionOneOfOriginal,
  ResourceType as ResourceTypeOriginal,
  Slug as SlugOriginal,
  URLs as URLsOriginal,
  PageUrlV2 as PageUrlV2Original,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  AddOnGroup as AddOnGroupOriginal,
  AddOnDetails as AddOnDetailsOriginal,
  TaxableAddress as TaxableAddressOriginal,
  TaxableAddressType as TaxableAddressTypeOriginal,
  TaxableAddressTypeWithLiterals as TaxableAddressTypeWithLiteralsOriginal,
  ServicesV2PhoneCall as ServicesV2PhoneCallOriginal,
  GetAnonymousActionTokenRequest as GetAnonymousActionTokenRequestOriginal,
  GetAnonymousActionTokenResponse as GetAnonymousActionTokenResponseOriginal,
  CreateMultiServiceBookingRequest as CreateMultiServiceBookingRequestOriginal,
  CreateBookingFlowControlSettings as CreateBookingFlowControlSettingsOriginal,
  CreateMultiServiceBookingResponse as CreateMultiServiceBookingResponseOriginal,
  MultiServiceBooking as MultiServiceBookingOriginal,
  BookingResult as BookingResultOriginal,
  RescheduleMultiServiceBookingRequest as RescheduleMultiServiceBookingRequestOriginal,
  RescheduleBookingInfo as RescheduleBookingInfoOriginal,
  RescheduleBookingInfoParticipantsInfoOneOf as RescheduleBookingInfoParticipantsInfoOneOfOriginal,
  RescheduleBookingFlowControlSettings as RescheduleBookingFlowControlSettingsOriginal,
  RescheduleMultiServiceBookingResponse as RescheduleMultiServiceBookingResponseOriginal,
  BookingRescheduled as BookingRescheduledOriginal,
  BookingRescheduledPreviousParticipantsInfoOneOf as BookingRescheduledPreviousParticipantsInfoOneOfOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  IdentityType as IdentityTypeOriginal,
  IdentityTypeWithLiterals as IdentityTypeWithLiteralsOriginal,
  GetMultiServiceBookingAvailabilityRequest as GetMultiServiceBookingAvailabilityRequestOriginal,
  GetMultiServiceBookingAvailabilityResponse as GetMultiServiceBookingAvailabilityResponseOriginal,
  BookingPolicyViolations as BookingPolicyViolationsOriginal,
  BookingPolicySettings as BookingPolicySettingsOriginal,
  GetMultiServiceBookingAvailabilityResponseBookingInfo as GetMultiServiceBookingAvailabilityResponseBookingInfoOriginal,
  CancelMultiServiceBookingRequest as CancelMultiServiceBookingRequestOriginal,
  CancelBookingFlowControlSettings as CancelBookingFlowControlSettingsOriginal,
  CancelMultiServiceBookingResponse as CancelMultiServiceBookingResponseOriginal,
  BookingCanceled as BookingCanceledOriginal,
  MarkMultiServiceBookingAsPendingRequest as MarkMultiServiceBookingAsPendingRequestOriginal,
  BookingInfo as BookingInfoOriginal,
  MarkBookingAsPendingFlowControlSettings as MarkBookingAsPendingFlowControlSettingsOriginal,
  MarkMultiServiceBookingAsPendingResponse as MarkMultiServiceBookingAsPendingResponseOriginal,
  ConfirmMultiServiceBookingRequest as ConfirmMultiServiceBookingRequestOriginal,
  ConfirmBookingFlowControlSettings as ConfirmBookingFlowControlSettingsOriginal,
  ConfirmMultiServiceBookingResponse as ConfirmMultiServiceBookingResponseOriginal,
  BookingConfirmed as BookingConfirmedOriginal,
  DeclineMultiServiceBookingRequest as DeclineMultiServiceBookingRequestOriginal,
  DeclineBookingFlowControlSettings as DeclineBookingFlowControlSettingsOriginal,
  DeclineMultiServiceBookingResponse as DeclineMultiServiceBookingResponseOriginal,
  BookingDeclined as BookingDeclinedOriginal,
  BulkGetMultiServiceBookingAllowedActionsRequest as BulkGetMultiServiceBookingAllowedActionsRequestOriginal,
  BulkGetMultiServiceBookingAllowedActionsResponse as BulkGetMultiServiceBookingAllowedActionsResponseOriginal,
  BulkCalculateAllowedActionsResult as BulkCalculateAllowedActionsResultOriginal,
  AllowedActions as AllowedActionsOriginal,
  GetMultiServiceBookingRequest as GetMultiServiceBookingRequestOriginal,
  GetMultiServiceBookingResponse as GetMultiServiceBookingResponseOriginal,
  MultiServiceBookingMetadata as MultiServiceBookingMetadataOriginal,
  AddBookingsToMultiServiceBookingRequest as AddBookingsToMultiServiceBookingRequestOriginal,
  BookingIdAndRevision as BookingIdAndRevisionOriginal,
  AddBookingsToMultiServiceBookingResponse as AddBookingsToMultiServiceBookingResponseOriginal,
  RemoveBookingsFromMultiServiceBookingRequest as RemoveBookingsFromMultiServiceBookingRequestOriginal,
  RemoveBookingsFromMultiServiceBookingResponse as RemoveBookingsFromMultiServiceBookingResponseOriginal,
  BookingChanged as BookingChangedOriginal,
  CreateBookingRequest as CreateBookingRequestOriginal,
  CreateBookingResponse as CreateBookingResponseOriginal,
  UpdateBookingRequest as UpdateBookingRequestOriginal,
  UpdateBookingResponse as UpdateBookingResponseOriginal,
  LegacyCreateBookingRequest as LegacyCreateBookingRequestOriginal,
  LegacyCreateBookingResponse as LegacyCreateBookingResponseOriginal,
  BulkUpdateBookingRequest as BulkUpdateBookingRequestOriginal,
  MaskedBooking as MaskedBookingOriginal,
  BulkUpdateBookingResponse as BulkUpdateBookingResponseOriginal,
  BulkCreateBookingRequest as BulkCreateBookingRequestOriginal,
  CreateBookingInfo as CreateBookingInfoOriginal,
  BulkCreateBookingResponse as BulkCreateBookingResponseOriginal,
  RescheduleBookingRequest as RescheduleBookingRequestOriginal,
  RescheduleBookingRequestParticipantsInfoOneOf as RescheduleBookingRequestParticipantsInfoOneOfOriginal,
  RescheduleBookingResponse as RescheduleBookingResponseOriginal,
  BulkRescheduleBookingRequest as BulkRescheduleBookingRequestOriginal,
  BulkRescheduleBookingRequestBooking as BulkRescheduleBookingRequestBookingOriginal,
  SlotBookings as SlotBookingsOriginal,
  BulkRescheduleBookingResponse as BulkRescheduleBookingResponseOriginal,
  BulkUpdateBookedScheduleRequest as BulkUpdateBookedScheduleRequestOriginal,
  BookingDetails as BookingDetailsOriginal,
  BulkUpdateBookedScheduleResponse as BulkUpdateBookedScheduleResponseOriginal,
  QueryBookingsRequest as QueryBookingsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryBookingsResponse as QueryBookingsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  CommonCursors as CommonCursorsOriginal,
  ConfirmRequest as ConfirmRequestOriginal,
  ConfirmResponse as ConfirmResponseOriginal,
  ConfirmBookingRequest as ConfirmBookingRequestOriginal,
  ConfirmBookingResponse as ConfirmBookingResponseOriginal,
  ConsistentQueryBookingsRequest as ConsistentQueryBookingsRequestOriginal,
  ConsistentQueryBookingsResponse as ConsistentQueryBookingsResponseOriginal,
  SetBookingSessionIdRequest as SetBookingSessionIdRequestOriginal,
  SetBookingSessionIdResponse as SetBookingSessionIdResponseOriginal,
  SetBookingSubmissionIdRequest as SetBookingSubmissionIdRequestOriginal,
  SetBookingSubmissionIdResponse as SetBookingSubmissionIdResponseOriginal,
  UpdateExtendedFieldsRequest as UpdateExtendedFieldsRequestOriginal,
  UpdateExtendedFieldsResponse as UpdateExtendedFieldsResponseOriginal,
  DeclineBookingRequest as DeclineBookingRequestOriginal,
  DeclineBookingResponse as DeclineBookingResponseOriginal,
  CancelBookingRequest as CancelBookingRequestOriginal,
  CancelBookingResponse as CancelBookingResponseOriginal,
  UpdateNumberOfParticipantsRequest as UpdateNumberOfParticipantsRequestOriginal,
  UpdateNumberOfParticipantsRequestParticipantsInfoOneOf as UpdateNumberOfParticipantsRequestParticipantsInfoOneOfOriginal,
  UpdateNumberOfParticipantsResponse as UpdateNumberOfParticipantsResponseOriginal,
  NumberOfParticipantsUpdated as NumberOfParticipantsUpdatedOriginal,
  NumberOfParticipantsUpdatedPreviousParticipantsInfoOneOf as NumberOfParticipantsUpdatedPreviousParticipantsInfoOneOfOriginal,
  BulkCalculateAllowedActionsRequest as BulkCalculateAllowedActionsRequestOriginal,
  BulkCalculateAllowedActionsResponse as BulkCalculateAllowedActionsResponseOriginal,
  GetSlotAvailabilityRequest as GetSlotAvailabilityRequestOriginal,
  GetSlotAvailabilityResponse as GetSlotAvailabilityResponseOriginal,
  SlotAvailability as SlotAvailabilityOriginal,
  WaitingList as WaitingListOriginal,
  AvailableResources as AvailableResourcesOriginal,
  GetScheduleAvailabilityRequest as GetScheduleAvailabilityRequestOriginal,
  GetScheduleAvailabilityResponse as GetScheduleAvailabilityResponseOriginal,
  ScheduleAvailability as ScheduleAvailabilityOriginal,
  MarkBookingAsPendingRequest as MarkBookingAsPendingRequestOriginal,
  MarkBookingAsPendingResponse as MarkBookingAsPendingResponseOriginal,
  BookingMarkedAsPending as BookingMarkedAsPendingOriginal,
  MigrationCheckIfClashesWithBlockedTimeRequest as MigrationCheckIfClashesWithBlockedTimeRequestOriginal,
  MsidAndBookingId as MsidAndBookingIdOriginal,
  MigrationCheckIfClashesWithBlockedTimeResponse as MigrationCheckIfClashesWithBlockedTimeResponseOriginal,
  Clash as ClashOriginal,
  CountBookingsRequest as CountBookingsRequestOriginal,
  CountBookingsResponse as CountBookingsResponseOriginal,
  SearchBookingsRequest as SearchBookingsRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  RangeBucket as RangeBucketOriginal,
  SortType as SortTypeOriginal,
  SortTypeWithLiterals as SortTypeWithLiteralsOriginal,
  SortDirection as SortDirectionOriginal,
  SortDirectionWithLiterals as SortDirectionWithLiteralsOriginal,
  MissingValues as MissingValuesOriginal,
  MissingValuesWithLiterals as MissingValuesWithLiteralsOriginal,
  IncludeMissingValuesOptions as IncludeMissingValuesOptionsOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  Interval as IntervalOriginal,
  IntervalWithLiterals as IntervalWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  ValueAggregationOptionsOneOf as ValueAggregationOptionsOneOfOriginal,
  NestedAggregationType as NestedAggregationTypeOriginal,
  NestedAggregationTypeWithLiterals as NestedAggregationTypeWithLiteralsOriginal,
  RangeAggregation as RangeAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  DateHistogramAggregation as DateHistogramAggregationOriginal,
  NestedAggregationItem as NestedAggregationItemOriginal,
  NestedAggregationItemKindOneOf as NestedAggregationItemKindOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  NestedAggregation as NestedAggregationOriginal,
  GroupByAggregation as GroupByAggregationOriginal,
  GroupByAggregationKindOneOf as GroupByAggregationKindOneOfOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  SearchBookingsResponse as SearchBookingsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  NestedAggregationResults as NestedAggregationResultsOriginal,
  NestedAggregationResultsResultOneOf as NestedAggregationResultsResultOneOfOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  NestedValueAggregationResult as NestedValueAggregationResultOriginal,
  ValueResult as ValueResultOriginal,
  RangeResult as RangeResultOriginal,
  ScalarResult as ScalarResultOriginal,
  ScalarDateResult as ScalarDateResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  DateHistogramResult as DateHistogramResultOriginal,
  GroupByValueResults as GroupByValueResultsOriginal,
  DateHistogramResults as DateHistogramResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  GetAnonymousActionDetailsRequest as GetAnonymousActionDetailsRequestOriginal,
  GetAnonymousActionDetailsResponse as GetAnonymousActionDetailsResponseOriginal,
  AnonymousBookingUrls as AnonymousBookingUrlsOriginal,
  CancelBookingAnonymouslyRequest as CancelBookingAnonymouslyRequestOriginal,
  CancelBookingAnonymouslyResponse as CancelBookingAnonymouslyResponseOriginal,
  RescheduleBookingAnonymouslyRequest as RescheduleBookingAnonymouslyRequestOriginal,
  RescheduleBookingAnonymouslyResponse as RescheduleBookingAnonymouslyResponseOriginal,
  GetBookingAnonymouslyRequest as GetBookingAnonymouslyRequestOriginal,
  GetBookingAnonymouslyResponse as GetBookingAnonymouslyResponseOriginal,
  AllowedActionsAnonymously as AllowedActionsAnonymouslyOriginal,
  AllowedAnonymousActions as AllowedAnonymousActionsOriginal,
  GetSchedulingUrlRequest as GetSchedulingUrlRequestOriginal,
  GetSchedulingUrlResponse as GetSchedulingUrlResponseOriginal,
  ConfirmOrDeclineBookingApplicationErrors as ConfirmOrDeclineBookingApplicationErrorsOriginal,
  BulkConfirmOrDeclineBookingApplicationErrors as BulkConfirmOrDeclineBookingApplicationErrorsOriginal,
  BookingsCancelBookingAnonymouslyApplicationErrors as BookingsCancelBookingAnonymouslyApplicationErrorsOriginal,
  BookingsRescheduleBookingAnonymouslyApplicationErrors as BookingsRescheduleBookingAnonymouslyApplicationErrorsOriginal,
  BookingsGetBookingAnonymouslyApplicationErrors as BookingsGetBookingAnonymouslyApplicationErrorsOriginal,
  GetServiceAnonymouslyApplicationErrors as GetServiceAnonymouslyApplicationErrorsOriginal,
  GetAnonymousActionTokenApplicationErrors as GetAnonymousActionTokenApplicationErrorsOriginal,
  CreateMultiServiceBookingApplicationErrors as CreateMultiServiceBookingApplicationErrorsOriginal,
  RescheduleMultiServiceBookingApplicationErrors as RescheduleMultiServiceBookingApplicationErrorsOriginal,
  GetMultiServiceBookingAvailabilityApplicationErrors as GetMultiServiceBookingAvailabilityApplicationErrorsOriginal,
  CancelMultiServiceBookingApplicationErrors as CancelMultiServiceBookingApplicationErrorsOriginal,
  MarkMultiServiceBookingAsPendingApplicationErrors as MarkMultiServiceBookingAsPendingApplicationErrorsOriginal,
  ConfirmMultiServiceBookingApplicationErrors as ConfirmMultiServiceBookingApplicationErrorsOriginal,
  DeclineMultiServiceBookingApplicationErrors as DeclineMultiServiceBookingApplicationErrorsOriginal,
  AddBookingsToMultiServiceBookingApplicationErrors as AddBookingsToMultiServiceBookingApplicationErrorsOriginal,
  RemoveBookingsFromMultiServiceBookingApplicationErrors as RemoveBookingsFromMultiServiceBookingApplicationErrorsOriginal,
  CreateBookingApplicationErrors as CreateBookingApplicationErrorsOriginal,
  BulkCreateBookingApplicationErrors as BulkCreateBookingApplicationErrorsOriginal,
  RescheduleBookingApplicationErrors as RescheduleBookingApplicationErrorsOriginal,
  BookingsConfirmBookingApplicationErrors as BookingsConfirmBookingApplicationErrorsOriginal,
  SetBookingSubmissionIdApplicationErrors as SetBookingSubmissionIdApplicationErrorsOriginal,
  UpdateExtendedFieldsApplicationErrors as UpdateExtendedFieldsApplicationErrorsOriginal,
  BookingsDeclineBookingApplicationErrors as BookingsDeclineBookingApplicationErrorsOriginal,
  BookingsCancelBookingApplicationErrors as BookingsCancelBookingApplicationErrorsOriginal,
  BookingsUpdateNumberOfParticipantsApplicationErrors as BookingsUpdateNumberOfParticipantsApplicationErrorsOriginal,
  MarkBookingAsPendingApplicationErrors as MarkBookingAsPendingApplicationErrorsOriginal,
} from './bookings-v2-booking-bookings.types.js';
